import { writable } from 'svelte/store';
import { SubtitlesService } from '@/services';
let initialState = {
    items: {
        raw: [],
        grouped: []
    },
    error: ''
};
// Init state
const { subscribe, update } = writable(initialState);
let __subtitles;
subscribe(sb => (__subtitles = sb));
const actions = {
    set: (updatedState) => {
        update(store => ({ ...store, ...updatedState }));
    },
    async getSubtitles(id) {
        const subtitles = await new SubtitlesService().getSubtitles(id);
        update(sb => {
            return {
                ...sb,
                items: subtitles
            };
        });
    },
    async downloadTranscript(id) {
        return await new SubtitlesService().downloadSubtitle(id);
    },
    getSubtitlesFromSelectedVideo(data) {
        const subtitles = new SubtitlesService().formatSubtitleObject(data.transcription);
        update(sb => {
            return {
                ...sb,
                items: subtitles
            };
        });
    },
    async getTranscriptionStatus(id) {
        return await new SubtitlesService().getTranscriptionStatus(id);
    },
    addFlexSearch(flexSearchCallback) {
        __subtitles.items.grouped.forEach((item, i) => {
            item.words.forEach((word) => {
                const __word = {
                    index: word.index,
                    word: word.word,
                    sIndex: item.index
                };
                flexSearchCallback(__word);
            });
        });
    },
    findSentenceOnPlay(currentTime) {
        return __subtitles.items.grouped.find(item => {
            const firstWord = item.words[0];
            const lastWord = item.words[item.words.length - 1];
            if (firstWord.timeStamp && lastWord.timeStamp) {
                return firstWord.timeStamp.startTime <= currentTime && currentTime < lastWord.timeStamp.endTime;
            }
            return false;
        });
    },
    moveWord(sentence) {
        update(sb => {
            sb.items.grouped.map(item => {
                if (item.index !== sentence.index)
                    return item;
                return sentence;
            });
            return sb;
        });
    }
};
const subtitles = {
    ...actions,
    subscribe
};
export default subtitles;
